import accountId from './accountId/accountIdSlice';

const root = {
	accountId
};

export default root;
